import React, { useEffect, useRef } from "react";
import { sanitizeRichText } from "../../utils/richText";

const RichTextEditor = ({ name, value, onChange, placeholder }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor || document.activeElement === editor) return;
    const safeValue = sanitizeRichText(value || "");
    if (editor.innerHTML !== safeValue) editor.innerHTML = safeValue;
  }, [value]);

  const updateValue = () => {
    onChange({
      target: { name, value: sanitizeRichText(editorRef.current?.innerHTML || "") },
    });
  };

  const format = (command, commandValue = null) => {
    editorRef.current?.focus();
    document.execCommand(command, false, commandValue);
    updateValue();
  };

  const addLink = () => {
    const url = window.prompt("Link URL (https://...)");
    if (url) format("createLink", url);
  };

  return (
    <div className="mt-1 overflow-hidden rounded-md border border-gray-300 bg-white shadow-sm">
      <div className="flex flex-wrap gap-1 border-b border-gray-200 bg-gray-50 p-2">
        <button type="button" className="rounded px-2 py-1 text-sm font-bold hover:bg-gray-200" onClick={() => format("bold")} aria-label="Bold">B</button>
        <button type="button" className="rounded px-2 py-1 text-sm italic hover:bg-gray-200" onClick={() => format("italic")} aria-label="Italic">I</button>
        <button type="button" className="rounded px-2 py-1 text-sm underline hover:bg-gray-200" onClick={() => format("underline")} aria-label="Underline">U</button>
        <button type="button" className="rounded px-2 py-1 text-sm hover:bg-gray-200" onClick={() => format("insertUnorderedList")} aria-label="Bullet list">• List</button>
        <button type="button" className="rounded px-2 py-1 text-sm hover:bg-gray-200" onClick={() => format("insertOrderedList")} aria-label="Numbered list">1. List</button>
        <button type="button" className="rounded px-2 py-1 text-sm hover:bg-gray-200" onClick={addLink} aria-label="Add link">Link</button>
      </div>
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={updateValue}
        data-placeholder={placeholder}
        className="min-h-[112px] whitespace-pre-wrap p-2 text-sm outline-none empty:before:text-gray-400 empty:before:content-[attr(data-placeholder)]"
      />
    </div>
  );
};

export default RichTextEditor;
